import { useState, useEffect, useCallback } from 'react'
import { format } from 'date-fns'
import { zhCN } from 'date-fns/locale'
import { useRecords } from '@/contexts/record-context'
import { useAuth } from '@/hooks/use-auth'
import { CategoryPanel } from '@/components/category-panel'
import { Timeline } from '@/components/timeline'
import { SyncStatus } from '@/components/sync-status'
import { getGreeting } from '@/lib/utils'
import { cn } from '@/lib/utils'
import { RefreshCw } from 'lucide-react'

export function HomePage() {
  const { user } = useAuth()
  const { todayRecords, loading, fetchTodayRecords } = useRecords()
  const [now, setNow] = useState(new Date())

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000)
    return () => clearInterval(timer)
  }, [])

  const handleRefresh = useCallback(() => {
    fetchTodayRecords()
  }, [fetchTodayRecords])

  return (
    <div className="flex flex-col min-h-[calc(100dvh-3.5rem)]">
      {/* Header */}
      <div className="px-5 pt-4 pb-3 safe-top">
        <div className="flex items-start justify-between mb-1">
          <div>
            <p className="text-xs text-muted-foreground mb-0.5">{getGreeting()}</p>
            <p className="text-2xl font-bold tracking-tight">
              {format(now, 'M月d日', { locale: zhCN })}
              <span className="text-sm font-normal text-muted-foreground ml-2">
                {format(now, 'HH:mm:ss')}
              </span>
            </p>
          </div>
          <div className="flex items-center gap-3">
            {user && (
              <span className="text-xs text-muted-foreground bg-muted/50 px-2 py-1 rounded-full">
                {user.nickname}
              </span>
            )}
            <SyncStatus />
          </div>
        </div>

        {/* Today summary */}
        <div className="flex items-center gap-2 mt-2">
          <span className="text-xs text-muted-foreground">
            今日 {todayRecords.length} 条记录
          </span>
          <button
            onClick={handleRefresh}
            disabled={loading}
            className="p-1 hover:bg-muted rounded-lg transition-colors disabled:opacity-50"
          >
            <RefreshCw className={cn('h-3 w-3 text-muted-foreground', loading && 'animate-spin')} />
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto px-5">
        {/* Category Panel */}
        <div className="mb-6">
          <CategoryPanel />
        </div>

        {/* Timeline */}
        <div className="pb-4">
          <h3 className="text-sm font-medium text-muted-foreground mb-3">今日记录</h3>
          <Timeline records={todayRecords} />
        </div>
      </div>
    </div>
  )
}
